import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useFormik } from "formik";
import { AddBlockListSchema } from "../../Validation";
import { useMutation } from "react-query";
import { toast } from "sonner";
import { CreateBlocklistApi } from "../../Api";
import { useLocation } from "react-router-dom";

interface PropsType {
  show: boolean;
  setShow: (v: boolean) => void;
  number: string;
  handleBlock: (v: boolean) => void;
}

interface BlocklistNumberType {
  number: string;
}

export default function AddBlocklist({
  show,
  setShow,
  number,
  handleBlock,
}: PropsType) {
  const { state } = useLocation();
  const { mutate } = useMutation(CreateBlocklistApi, {
    mutationKey: "Create_Block_List",
    onSuccess: (data: any) => {
      resetForm();
      setShow(false);
      toast.success(data?.data?.message || "Number added to blocklist");
      handleBlock(true);
    },
    onError: (data: any) => {
      setSubmitting(false);
      toast.error(data?.response?.data?.message || "Something wrong.");
    },
  });

  const { errors, resetForm, isSubmitting, handleSubmit, setSubmitting } =
    useFormik<BlocklistNumberType>({
      initialValues: {
        number: number,
      },
      enableReinitialize: true,
      validationSchema: AddBlockListSchema,
      onSubmit: (data) => {
        mutate({ number: data.number, campaign_id: state?.id });
      },
    });

  return (
    <Modal show={show} centered onHide={() => setShow(false)} backdrop="static">
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <h5 className="text-center">
              Are you sure you want to block this number?
            </h5>
          </div>

          <div className="form-group mb-3">
            {errors.number ? (
              <div className="text-danger">{errors.number}</div>
            ) : null}
          </div>

          <Modal.Footer className="d-flex justify-content-center border-0">
            <Button
              variant="primary"
              type="submit"
              disabled={isSubmitting}
              style={{ minWidth: 76.5 }}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span className="ps-2">Processing...</span>
                </>
              ) : (
                "Yes"
              )}
            </Button>
            <Button
              style={{ width: 76.5 }}
              variant="secondary"
              onClick={() => {
                setShow(false);
                resetForm();
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  );
}
